// extracted by mini-css-extract-plugin
module.exports = {"varSpBase":"1rem","varSpUp2":"1.5rem","settingsRailBody":"settingsRailBody--8baf5","header":"header--9504b primaryBold--1abd6"};